export const mergeUrlApi = (first = "", second = "") => {
  return addEndSlash(first) + removeFirstSlash(second);
};

export const addEndSlash = (text) => {
  return text.slice(-1) === "/" ? text : text.concat("/");
};
export const removeFirstSlash = (text) => {
  return text[0] === "/" ? text.slice(1) : text;
};
